"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitInspiroiduOluesta = void 0;
function InitInspiroiduOluesta() {
    // CategoryFilterBlock
    const submitForm = (cats, order, allCats, skipCount, showMoreCount, showMorePage) => {
        // Show loading element
        jQuery('#pagelistwrapper-content-loading').show();
        // Disable pointer events in Category selector
        jQuery('.category-filter-form').css('pointer-events', 'none');
        // Disable pointer events in content to prevent link clicks in mobile if category buttons are pushed repeatedly. 
        jQuery('.content-wrapper').addClass('remove-pointer-events');
        const rvt = jQuery('input[name=__RequestVerificationToken]').val(); // __RequestVerificationToken
        jQuery.ajax({
            type: 'POST',
            url: '?categories=' + cats + '&ordering=' + order + '&allcategories=' + allCats + '&skipItems=' + skipCount + '&showMoreItems=' + showMoreCount + '&showMorePage=' + showMorePage,
            data: {
                __RequestVerificationToken: rvt
            },
            contentType: 'application/x-www-form-urlencoded; charset=utf-8',
            error: function (xhr) {
                console.log('Error: ' + xhr.statusText);
            },
            success: function (result) {
                let template = jQuery.parseHTML(result);
                let final = $(template).find('#article-results');
                jQuery('#article-results').html(final.html());
                // Hide loading element and enable pointer events in Category selector
                setTimeout(() => {
                    jQuery('#pagelistwrapper-content-loading').hide();
                    jQuery('.category-filter-form').css('pointer-events', 'all');
                    jQuery('#article-results').css('visibility', 'visible');
                    jQuery('.content-wrapper').removeClass('remove-pointer-events');
                }, 300);
            },
            async: true
        });
    };
    const getSelectedCategories = (returnAll) => {
        let catString = '';
        let first = true;
        const catSelector = (returnAll) ? 'input[name=categories]' : 'input[name=categories]:checked';
        jQuery(catSelector).each(function () {
            if (jQuery(this).prop("value") !== undefined && jQuery(this).prop("value").length > 0) {
                if (!first) {
                    catString += ",";
                }
                catString += jQuery(this).prop("value");
                first = false;
            }
        });
        return catString;
    };
    // On page load
    if (jQuery('form.category-filter-form').length) {
        const catString = getSelectedCategories(true);
        const allCategories = jQuery('input[name=allcategories]').prop('value');
        submitForm(catString, 'date', allCategories, '0', '0', '1');
    }
    jQuery("input[name=categories]").on("change", function () {
        let selectAll = false;
        // Reset filter when "new-cat-all" option is selected
        if (jQuery(this).attr("id") === "new-cat-all") {
            selectAll = true;
            jQuery("input[name=categories]:checked").prop("checked", false);
            jQuery(this).prop('checked', true);
        }
        else {
            jQuery("input[name=categories]#new-cat-all").prop("checked", false);
            // No filter categories selected
            if (jQuery("input[name=categories]:checked:not('#new-cat-all')").length === 0) {
                selectAll = true;
                jQuery("input[name=categories]#new-cat-all").prop('checked', true);
            }
        }
        const catString = getSelectedCategories(selectAll);
        const order = jQuery('input[name=ordering]:checked').prop('value');
        const allCategories = jQuery('input[name=allcategories]').prop('value');
        submitForm(catString, order, allCategories, '0', '0', '1');
    });
    jQuery("input[name=ordering]").on("change", function () {
        console.log(jQuery('input[name=categories]#new-cat-all').prop('checked'));
        const selectAll = (jQuery('input[name=categories]#new-cat-all').prop('checked')) ? true : false;
        const catString = getSelectedCategories(selectAll);
        const order = jQuery('input[name=ordering]:checked').prop('value');
        const allCategories = jQuery('input[name=allcategories]').prop('value');
        submitForm(catString, order, allCategories, '0', '0', '1');
    });
    jQuery('#open-mobile-filters').click(function () {
        jQuery('.filters-wrapper').slideDown();
        jQuery(this).hide();
        jQuery('.mobile-category-filter-layer').show();
    });
    jQuery('#hide-mobile-filters').click(function () {
        jQuery('.filters-wrapper').slideUp();
        jQuery('#open-mobile-filters').show();
        jQuery('.mobile-category-filter-layer').hide();
    });
    jQuery('.mobile-category-filter-layer').click(function () {
        jQuery('.filters-wrapper').slideUp();
        jQuery('#open-mobile-filters').show();
        jQuery('.mobile-category-filter-layer').hide();
    });
    window.loadMoreClick = (amount, page) => {
        const selectAll = (jQuery('input[name=categories]#new-cat-all').prop('checked')) ? true : false;
        const catString = getSelectedCategories(selectAll);
        const order = jQuery('input[name=ordering]:checked').prop('value');
        const allCategories = jQuery('input[name=allcategories]').prop('value');
        const showMoreAmount = amount;
        const showMorePage = page;
        submitForm(catString, order, allCategories, '0', showMoreAmount, showMorePage);
    };
    // Page List Wrapper Block
    window.filterList = () => {
        event.preventDefault();
        jQuery(window).scrollTop(0);
        const skipCount = jQuery(event.target).data('skip');
        const catString = jQuery(event.target).data('category');
        const order = jQuery('input[name=ordering]:checked').prop('value');
        const allCategories = jQuery('input[name=allcategories]').prop('value');
        jQuery("input[name=categories]").prop("checked", false);
        jQuery("input[name=categories][value=" + catString + "]").prop("checked", true);
        submitForm(catString, order, allCategories, skipCount, '0', '1');
    };
}
exports.InitInspiroiduOluesta = InitInspiroiduOluesta;
